export default __webpack_public_path__ + "e3a17114d982b3a8e6a64b5fd7d44f9a.png";